<template>
  <v-dialog v-model="dialog" height="60%" width="60%">
    <v-card>
      <v-toolbar color="primary" flat dense>
        <v-spacer></v-spacer>
        <v-btn color="white" class="ml-auto" @click="downloadImage(url)" icon>
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn color="white" class="ml-auto" @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-img :src="url" :lazy-src="url" contain aspect-ratio="1" max-height="60%" max-width="60%" class="grey lighten-2">
        </v-img>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import imageToBase64 from 'image-to-base64/browser';

export default {
  name: "ChatPreviewImage",
  components: {
  },
  data() {
    return {
      dialog: false,
      url: "",
    }
  },
  methods: {
    open(url) {
      this.dialog = true;
      this.url = url;
    },
    close() {
      this.dialog = false;
    },
    async downloadImage(url) {
      try {
        const ImageUrl = url;
        const ImageBase64 = await imageToBase64(ImageUrl);
        const a = document.createElement('a');
        a.href = 'data:image/png;base64,' + ImageBase64;
        a.download = 'Image.png';
        a.click();
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>